import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { ConditionType, CONDITION_TYPES } from '@nexxt/common/types';
import { HELPER_TOOLTIP_MAPPING } from '../../../../mapping/helperTooltip';

export const AddRuleButton: React.SFC<{
    onAddClick: () => void;
    hide: boolean;
    disabled: boolean;
}> = ({ onAddClick, hide, disabled }) => {
    if (hide) {
        return null;
    }
    return (
        <div className="row">
            <div className="col-md-12 option-list">
                <button
                    className="button button-small"
                    onClick={onAddClick}
                    disabled={disabled}
                    data-tip="add rule"
                    data-for="add-rule-button"
                >
                    <i className="nx nx-add" />
                    <span className="title">Add rule</span>
                </button>
                <ReactTooltip
                    id="add-rule-button"
                    aria-haspopup="true"
                    effect="solid"
                    place="bottom"
                    backgroundColor="#595959"
                    className="longContent"
                >
                    {HELPER_TOOLTIP_MAPPING['Add Rules']}
                </ReactTooltip>
            </div>
        </div>
    );
};

/**
 *
 * @param [type] "IPreCondition" | "postcondition"
 * @param [onSelect] (type: "IPreCondition" | "postcondition") => void;
 */
export const SelectCondtionType: React.SFC<{
    type: ConditionType;
    onSelect: (type: ConditionType) => void;
}> = ({ type, onSelect }) => (
    <div className="conditions-head">
        <div
            className={`radio-custom`}
            onClick={() => onSelect(CONDITION_TYPES.PRECONDITION)}
        >
            <input
                type="radio"
                name={'conditionType'}
                checked={type === CONDITION_TYPES.PRECONDITION}
            />
            <label className="input-radio">
                <b>Pre-condition</b>
                <span>
                    Enable this question if respondent came from [Question] and
                    answered with [Option]{' '}
                </span>
            </label>
        </div>
        <div
            className={`radio-custom`}
            onClick={() => onSelect(CONDITION_TYPES.POSTCONDITION)}
        >
            <input
                type="radio"
                name={'conditionType'}
                checked={type === CONDITION_TYPES.POSTCONDITION}
            />
            <label className="input-radio">
                <b>Post-condition</b>
                <span>If respondent selects [Option] from this [Question]</span>
            </label>
        </div>
    </div>
);

export const AddConditionButton: React.SFC<{
    onAddClick: () => void;
    hide: boolean;
    disabled: boolean;
}> = ({ onAddClick, hide, disabled }) => {
    if (hide) {
        return null;
    }
    return (
        <div className="option-list">
            <button
                className="button button-large"
                onClick={onAddClick}
                disabled={disabled}
                data-tip="add condition"
                data-for="add-condition-button"
            >
                <i className="nx nx-add" />
                <span className="title">Add conditions</span>
            </button>
            <ReactTooltip
                id="add-condition-button"
                aria-haspopup="true"
                effect="solid"
                place="bottom"
                backgroundColor="#595959"
                className="longContent"
            >
                {HELPER_TOOLTIP_MAPPING['Add Condition']}
            </ReactTooltip>
        </div>
    );
};

export const EditDeleteButtons: React.SFC<{
    onEdit: () => void;
    onDelete: () => void;
    show: boolean;
    ruleId: any;
    disabled: boolean;
}> = ({ show, onEdit, onDelete, ruleId, disabled }) => {
    if (show) {
        return (
            <ul className="collapse-action ml-auto">
                <li
                    className={`collapse-action__item ${
                        disabled ? 'disabled' : ''
                    }`}
                    onClick={!disabled && onEdit}
                    data-tip="custom show"
                    data-for={`edit-button-${ruleId}`}
                >
                    <a>
                        <i className="nx nx-edit"></i>
                    </a>
                </li>
                <ReactTooltip
                    id={`edit-button-${ruleId}`}
                    aria-haspopup="true"
                    effect="solid"
                    place="bottom"
                    disable={disabled}
                >
                    <span>Edit condition</span>
                </ReactTooltip>
                <li
                    className={`collapse-action__item ${
                        disabled ? 'disabled' : ''
                    }`}
                    onClick={!disabled && onDelete}
                >
                    <a>
                        <i
                            className="nx nx-delete"
                            data-tip="custom show"
                            data-for={`delete-button-${ruleId}`}
                        ></i>
                    </a>
                </li>
                <ReactTooltip
                    id={`delete-button-${ruleId}`}
                    aria-haspopup="true"
                    effect="solid"
                    place="bottom"
                    disable={disabled}
                >
                    <span>Delete condition</span>
                </ReactTooltip>
            </ul>
        );
    } else {
        return null;
    }
};
